import ERROR_ICON from '@assets/icons/error.svg'
import { useTranslation } from 'react-i18next'
import clsx from 'clsx'

export const ErrorUI = ({
  title,
  message = '정보를 불러오지 못했습니다',
  buttonLabel = '다시 시도',
  handleClick,
  className,
  height
}) => {
  const { t } = useTranslation()

  return (
    <div
      className={clsx('flex flex-col items-center justify-center gap-8 text-center', className)}
      style={height ? { height: `${height}px` } : undefined}
    >
      <img
        src={ERROR_ICON}
        alt={t('common.errorAlt')}
        width={54}
        height={47}
        className={'mr-8'}
        decoding="async"
      />
      {title && <h2 className={'text-18 mt-24 font-bold'}>{title}</h2>}
      {message && <p className={clsx('text-navy-400', title ? 'text-12' : 'text-14')}>{message}</p>}
      {handleClick && (
        <button
          className={'bg-navy-900 text-14 rounded-3xl px-16 py-8 text-white'}
          onClick={handleClick}
        >
          {buttonLabel}
        </button>
      )}
    </div>
  )
}
